import { c as _c } from "react/compiler-runtime";
import { ContactFiledInterface, ContactSlugEnum, CountryEnum, FormInput, FormInputPhone, FormSelect, Tooltip, getContactFieldTitle, getContactSlugName, getCountryData, useTranslation as useUiTranslation } from '@systemeio/ui';
import { deleteField } from 'modules/contacts/contact-page/api/contact-edit-api';
import { ContactFieldApiInterface } from 'modules/contacts/types/contact-filter-interface';
import { useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { KeyedMutator } from 'swr';
import { BinIcon } from '@systemeio/ui/icons';
interface ContactEditFieldProps {
  field: ContactFiledInterface;
  value: string | undefined;
  onChange: (value?: string) => void;
  className?: string;
  mutateFields?: KeyedMutator<ContactFieldApiInterface>;
  type: 'create' | 'edit';
  error?: string;
}
const ContactFields = t0 => {
  const $ = _c(50);
  const {
    field,
    onChange,
    className,
    value,
    mutateFields,
    type,
    error
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    user
  } = useUser();
  const [opened, setOpened] = useState(false);
  let t1;
  if ($[0] !== field || $[1] !== tUi) {
    t1 = getContactFieldTitle(field, tUi);
    $[0] = field;
    $[1] = tUi;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const contactFieldTitle = t1;
  let t2;
  if ($[3] !== mutateFields) {
    t2 = async id => {
      if (typeof mutateFields === "undefined") {
        return;
      }
      await deleteField(id);
      await mutateFields(data => {
        if (data) {
          return {
            ...data,
            items: [...data.items.filter(el => el.id !== id)]
          };
        }
      }, false);
    };
    $[3] = mutateFields;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onDeleteField = t2;
  switch (field.slug) {
    case ContactSlugEnum.Country:
      {
        let t3;
        if ($[5] !== tUi) {
          t3 = getContactSlugName(ContactSlugEnum.Country, tUi);
          $[5] = tUi;
          $[6] = t3;
        } else {
          t3 = $[6];
        }
        let t4;
        if ($[7] !== tUi) {
          t4 = getContactSlugName(ContactSlugEnum.Country, tUi);
          $[7] = tUi;
          $[8] = t4;
        } else {
          t4 = $[8];
        }
        const t5 = user?.dashboardLocale;
        let t6;
        if ($[9] !== t5) {
          t6 = getCountryData(t5);
          $[9] = t5;
          $[10] = t6;
        } else {
          t6 = $[10];
        }
        const t7 = value as CountryEnum;
        let t8;
        if ($[11] !== className || $[12] !== error || $[13] !== onChange || $[14] !== t3 || $[15] !== t4 || $[16] !== t6 || $[17] !== t7) {
          t8 = <FormSelect containerClassName={className} label={t3} placeholder={t4} data={t6} value={t7} onChange={onChange} error={error} />;
          $[11] = className;
          $[12] = error;
          $[13] = onChange;
          $[14] = t3;
          $[15] = t4;
          $[16] = t6;
          $[17] = t7;
          $[18] = t8;
        } else {
          t8 = $[18];
        }
        return t8;
      }
    case ContactSlugEnum.PhoneNumber:
      {
        let t3;
        if ($[19] !== tUi) {
          t3 = getContactSlugName(ContactSlugEnum.PhoneNumber, tUi);
          $[19] = tUi;
          $[20] = t3;
        } else {
          t3 = $[20];
        }
        let t4;
        if ($[21] !== tUi) {
          t4 = getContactSlugName(ContactSlugEnum.PhoneNumber, tUi);
          $[21] = tUi;
          $[22] = t4;
        } else {
          t4 = $[22];
        }
        let t5;
        if ($[23] !== className || $[24] !== error || $[25] !== onChange || $[26] !== t3 || $[27] !== t4 || $[28] !== value) {
          t5 = <FormInputPhone wrapperClassName={className} label={t3} placeholder={t4} value={value} onChange={onChange} error={error} />;
          $[23] = className;
          $[24] = error;
          $[25] = onChange;
          $[26] = t3;
          $[27] = t4;
          $[28] = value;
          $[29] = t5;
        } else {
          t5 = $[29];
        }
        return t5;
      }
    default:
      {
        const t3 = field.slug === ContactSlugEnum.Email && type === "create";
        const t4 = field.slug === ContactSlugEnum.Email && type === "edit";
        let t5;
        if ($[30] !== onChange) {
          t5 = e => onChange(e.target.value);
          $[30] = onChange;
          $[31] = t5;
        } else {
          t5 = $[31];
        }
        const t6 = field.slug !== ContactSlugEnum.Email ? "w-full" : "";
        let t7;
        if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = {
            htmlFor: "none"
          };
          $[32] = t7;
        } else {
          t7 = $[32];
        }
        let t8;
        if ($[33] !== contactFieldTitle || $[34] !== field.id || $[35] !== field.slug || $[36] !== onDeleteField || $[37] !== opened || $[38] !== t) {
          t8 = Object.values(ContactSlugEnum).includes(field.slug as ContactSlugEnum) ? contactFieldTitle : <div className="flex w-full justify-between">{contactFieldTitle}<Tooltip mode="hover" label={t("dashboard.contact_page.delete_contact_field")}><button onClick={() => setOpened(true)} className="group outline-hidden"><BinIcon className="main-transition-colors group-hover:fill-danger group-focus-visible:fill-danger h-[20px] w-[20px]" /></button></Tooltip><ConfirmationModal confirmationText={t("dashboard.contact_page.delete_contact_field_description")} toastCaption={t("dashboard.contact_page.field_removed")} opened={opened} onClose={() => setOpened(false)} onConfirm={() => onDeleteField(field.id)} /></div>;
          $[33] = contactFieldTitle;
          $[34] = field.id;
          $[35] = field.slug;
          $[36] = onDeleteField;
          $[37] = opened;
          $[38] = t;
          $[39] = t8;
        } else {
          t8 = $[39];
        }
        let t9;
        if ($[40] !== className || $[41] !== contactFieldTitle || $[42] !== error || $[43] !== t3 || $[44] !== t4 || $[45] !== t5 || $[46] !== t6 || $[47] !== t8 || $[48] !== value) {
          t9 = <FormInput required={t3} disabled={t4} className={className} value={value} error={error} onChange={t5} labelClassName={t6} nativeLabelProps={t7} label={t8} placeholder={contactFieldTitle} />;
          $[40] = className;
          $[41] = contactFieldTitle;
          $[42] = error;
          $[43] = t3;
          $[44] = t4;
          $[45] = t5;
          $[46] = t6;
          $[47] = t8;
          $[48] = value;
          $[49] = t9;
        } else {
          t9 = $[49];
        }
        return t9;
      }
  }
};
export default ContactFields;